import React from 'react';
import {AchieveRecommendCard} from '../../../../types/MyDynamicsData';
import check from '../../../../assets/img/icons/check.svg';
import check_active from '../../../../assets/img/icons/check_active.svg';
import styles from './RecommendCard.module.css';

type Props = {
	card: AchieveRecommendCard;
	isActive?: boolean;
};

const RecommendCard: React.FC<Props> = ({card, isActive = false}) => {
	const {text} = card;
	return (
		<div className={`${styles.item} ${isActive ? styles.active : ''}`}>
			<div className={styles.icon}>
				<img src={isActive ? check_active : check} alt="check" />
			</div>
			<div className={`${styles.text} ${isActive ? styles.active : ''}`}>
				{text}
			</div>
		</div>
	);
};

export default RecommendCard;
